<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14waOAK/tc-custom/9781453260746.jpg?1726617321233" alt="This image is the cover for the book Beauty Kill, The Narc Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beauty Kill, The Narc Series
      </h1>
      <p class="bookDescription body article font2">
        <b>On the verge of death from two gunshot wounds, Bolt vows revenge</b><p class="MsoNormal">They call him Black Beauty, because he is the most gorgeous thief the drug world has ever seen. Where some are content to make a living ripping off dime-bag hustlers, Black Beauty steals from big-time dealers, taking profits from international cartels to keep himself rich, well-dressed, and smiling. His latest score netted him $850,000, along with the twenty-two kilos of cocaine the money was intended to buy. To get it he killed four men, and left one narcotics agent to bleed to death in a parking lot. Before long, Black Beauty will wish he finished the job. </p><p class="MsoNormal"></p><p class="MsoNormal">John Bolt is too tough to let a pretty boy kill him. As soon as he’s strong enough to lift a .45, he’s coming after Black Beauty—even if he has to take vengeance from a wheelchair.  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marc Olden
      </h2>
      
      <p class="authorDescription body article">Marc Olden (1933&ndash;2003) was the author of forty mystery and suspense novels. Born in Baltimore, he began writing while working in New York as a Broadway publicist. His first book,&#160;<I>Angela Davis</I>&#160;(1973), was a nonfiction study of the controversial Black Panther. In 1973 he also published&#160;<I>Narc</I>, under the name Robert Hawke, beginning a hard-boiled nine-book series about a federal narcotics agent.<P>A year later,&#160;<I>Black Samurai</I>&#160;introduced Robert Sand, a martial arts expert who becomes the first non-Japanese student of a samurai master. Based on Olden&rsquo;s own interest in martial arts, which led him to the advanced ranks of karate and aikido, the novel spawned a successful eight-book series. Olden continued writing for the next three decades, often drawing on his fascination with Japanese culture and history.&#160;</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8f5d8480